
import moment from 'moment'
import Vue, { PropType } from 'vue'
import api from '../../api/api'
import { getSimpleReportsData, getServiceList, getTaggingData } from '../../api/chisai/GCB2'

import Breadcrumbs from '../../components/Breadcrumbs.vue'
import LineChart from '../../components/charts/LineChart'
import SpinnerLoader from '../../components/SpinnerLoader.vue'
import { Connector, Project, ProjectType } from '../../types/main'
import { CONNECTOR_TYPES } from '../../vars/general'
import BaseInputOutlined from '../../components/inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '../../components/inputs/CustomActivatorSelect.vue'
import ServicesByTagsSelect from '../../components/inputs/ServicesByTagsSelect.vue'
import pickBy from 'lodash/pickBy'
import isObject from 'lodash/isObject'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import setWith from 'lodash/setWith'
import VideoHelper from '@root/src/components/VideoHelper.vue'
export default Vue.extend({
    name: 'GCB2MarketingReport',
    components: {
        Breadcrumbs,
        SpinnerLoader,
        LineChart,
        CustomActivatorSelect,
        BaseInputOutlined,
        ServicesByTagsSelect,
        VideoHelper
    },

    data: () => ({
        pageLoading: false,
        dashboardDataLoading: false,
        dateMenu: false,
        dates: [] as string[],
        staffNames: [] as string[],
        staffNamesList: [] as string[],
        dateFormat: 'DD.MM.YYYY',
        datePickerDateFormat: 'YYYY-MM-DD',
        filters: { productsDisplay: 1 } as any,
        inititalFilters: {},
        selectedProjectId: null as string | null,
        lorealServices: [] as any[],
        selectedLorealServices: [] as string[],
        lorealTagsMapping: null as any,
        dashboardData: {
            visit: {},
            revenue: {},
            averageСheck: {},
            newClients: {},
            uniqClients: {},
            canceledVisits: {},
        } as any,
        chartOptions: {
            legend: {
                labels: {
                    usePointStyle: true,
                },
            },
            plugins: {
                datalabels: false,
            },
            scales: {
                xAxes: [
                    {
                        type: 'category',
                    },
                ],
            },
            tooltips: {
                callbacks: {
                    title: (tooltipItems: any, data: any) => {
                        return data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index].x
                    },
                },
            },
            maintainAspectRatio: false,
        } as any,
        chartHeight: 300,
        showVideoHelp: true
    }),
    watch: {},
    computed: {
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        projectType(): ProjectType {
            return this.$store.getters.projectType;
        },
        isPseudoNetwork(): boolean {
            return this.projectType === 'pseudo_network'
        },
        isLorealProject(): boolean {
            return this.project.clusters && this.project.clusters.includes('loreal')
        },
        networkProjects() {
            return this.$store.getters.networkProjects;
        },
        pseudoNetworkProjects() {
            return this.$store.getters.pseudoNetworkProjects;
        },
        connector(): Connector | undefined {
            return this.project.connectors.find(el => el.connectorType === CONNECTOR_TYPES.GCB2)
        },
        isVideoHintHidden(): boolean {
            return this.connector?.videoHintDisabled
        },
        breadcrumbs(): Array<any> {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'Общие отчеты',
                    to: '',
                    disabled: true,
                },
            ]
        },
        chartStyles(): any {
            return {
                height: `${this.chartHeight}px`,
                position: 'relative',
            }
        },
        dateRangeText(): string {
            const formatedDates = this.sortedDates.map(date =>
                moment(date, this.datePickerDateFormat).format(this.dateFormat)
            )
            return formatedDates.join(' - ')
        },
        sortedDates(): string[] {
            return [
                ...this.dates.sort(
                    (a, b) =>
                        moment(a, this.datePickerDateFormat).unix() -
                        moment(b, this.datePickerDateFormat).unix()
                ),
            ]
        },
        displayFilters(): any {
            return {
                staffList: Object.values(this.filters.staffList ?? {})
                    .filter((el: any) => el.selected)
                    .map((el: any) => el.option),
                servicesList: Object.values(this.filters.servicesList ?? {})
                    .filter((el: any) => el.selected)
                    .map((el: any) => el.option),
            }
        },
        filtersLists(): any {
            return {
                staffList: Object.values(this.filters.staffList ?? {}).map((el: any) => ({
                    id: el.option,
                    name: el.option,
                })),

                servicesList: Object.values(this.filters.servicesList ?? {}).map((el: any) => ({
                    id: el.option,
                    name: el.option,
                })),

                productsDisplay: [
                    { id: 1, name: 'Только услуги' },
                    { id: 2, name: 'Услуги и товары, купленные с услугами' },
                    { id: 3, name: 'Все услуги и товары' },
                ],
            }
        },
        queryFilters(): any {
            const filters: any = {
                dateFrom: this.sortedDates[0],
                dateTo: this.sortedDates[1],
                productsDisplay: this.filters.productsDisplay,
                staffList: this.filters.staffList,
            }

            // Добавляем фильтр по услугам Лореаль, если они выбраны
            if (this.isLorealProject && this.selectedLorealServices.length > 0) {
                // Преобразуем в формат, ожидаемый бэкендом
                const servicesList = {}
                this.selectedLorealServices.forEach(serviceId => {
                    servicesList[serviceId] = {
                        option: serviceId,
                        selected: true
                    }
                })
                filters.servicesList = servicesList
            }

            return pickBy(filters, (v, k) => {
                // Для servicesList используем отдельную логику
                if (k === 'servicesList') {
                    return !isEmpty(v)
                }

                if (isObject(v) && isEmpty(v)) {
                    return false
                }
                if (
                    !isNil(v) &&
                    this.displayFilters[k] &&
                    (this.filtersLists[k].length === this.displayFilters[k].length ||
                        this.displayFilters[k].length === 0)
                ) {
                    return false
                }
                return true
            })
        },
    },
    methods: {
        setDefaultDates() {
            this.dates = [
                moment()
                    .subtract(4, 'year')
                    .format(this.datePickerDateFormat),
                moment().format(this.datePickerDateFormat),
            ]
        },

        dropFilters() {
            this.setDefaultDates()
            this.filters = Object.assign({}, this.inititalFilters)
            this.selectedLorealServices = []
            this.initData(true)
        },
        setFilterValue(filterId: string, val: any) {
            const updatedFilterVal = {}
            const selectedHmap = val.reduce((a: any, c: any) => Object.assign(a, { [c]: true }), {})
            this.filtersLists[filterId].forEach((el: any) => {
                setWith(
                    updatedFilterVal,
                    [el.id],
                    {
                        option: el.id,
                        selected: Boolean(selectedHmap[el.id]),
                    },
                    Object
                )
            })
            this.filters = Object.assign({}, this.filters, { [filterId]: updatedFilterVal })
        },
        async initData(initial: boolean) {
            this.dashboardDataLoading = true
            if (initial) {
                this.selectedProjectId = this.project.id
            }

            // Загружаем список услуг и теги для проектов Лореаль
            if (this.isLorealProject) {
                try {
                    const projectId = this.isPseudoNetwork ? this.selectedProjectId : this.project.id

                    // Загружаем данные тегов
                    const { data: taggingData } = await getTaggingData({ projectId })

                    // Извлекаем маппинг для кластера Лореаль
                    if (taggingData && taggingData.filtersData) {
                        const lorealCluster = taggingData.filtersData.find((cluster: any) => cluster.name === 'Лореаль')
                        if (lorealCluster) {
                            // Создаем маппинг групп, подгрупп и их связей
                            const groupsMap: any = {}
                            const subgroupsMap: any = {}
                            const subgroupToGroupMap: any = {}

                            lorealCluster.children.forEach((item: any) => {
                                // Пропускаем статусные теги
                                if (['unassigned', 'delayed', 'needToConfirm'].includes(item.id)) {
                                    return
                                }

                                // Это группа с подгруппами
                                groupsMap[item.id] = item.name

                                if (item.children && Array.isArray(item.children)) {
                                    item.children.forEach((subitem: any) => {
                                        subgroupsMap[subitem.id] = subitem.name
                                        // Запоминаем связь подгруппа -> группа
                                        subgroupToGroupMap[subitem.id] = item.id
                                    })
                                }
                            })

                            this.lorealTagsMapping = {
                                groups: groupsMap,
                                subgroups: subgroupsMap,
                                subgroupToGroup: subgroupToGroupMap
                            }
                        }
                    }

                    // Загружаем список услуг
                    const { data: servicesData } = await getServiceList({ projectId })

                    // Преобразуем теги на фронтенде
                    this.lorealServices = servicesData?.map((service: any) => {
                        let transformedTags = []
                        if (service.tags && Array.isArray(service.tags)) {
                            transformedTags = service.tags.map((tag: any) => ({
                                cluster: tag.cluster || 'agency',
                                status: tag.status,
                                group: tag.group || null,
                                subgroup: tag.subgroup || null,
                            }))
                        }

                        return {
                            id: service.id,
                            name: service.name,
                            category: service.category,
                            tags: transformedTags
                        }
                    }) || []
                } catch (error) {
                    console.error('Ошибка загрузки списка услуг:', error)
                }
            }

            const { data, error } = await getSimpleReportsData({
                projectId: this.isPseudoNetwork ? this.selectedProjectId : this.project.id,
                filters: this.queryFilters,
            })
            if (error) {
                this.$store.dispatch('callNotify', 'Ошибка')
            }
            this.dashboardData = data.chartsData
            this.filters = Object.assign({}, this.filters, data.filters)
            this.dashboardDataLoading = false
        },
        setVideoHelepVisible(value) {
            this.showVideoHelp = value
        }
    },
    async mounted() {
        this.inititalFilters = Object.assign({}, this.filters)
        this.pageLoading = true
        this.setDefaultDates()
        await this.initData(true)
        this.pageLoading = false
    },
})
